import React, { useEffect, useState } from "react";
import styles from "./gacha.module.css";
import StarContainer from "../../components/star-container/star-container";
import Header from "../../components/header/header";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../../components/footer/footer";
import ScrollUpButton from "../../components/buttons/scroll-up-button/scroll-up-button";
import { v4 } from "uuid";
import { GACHA_TYPE, GRADE, SSR_TYPE } from "../../functions/gachaFunctions";
import { reset, setIsPickup, setSaviorPickupType, setSnipeTarget, setSnipeType, tryOne, tryTen } from "../../store/reducers/list/gachaList";
import { selectGachaState, selectSnipeGacha, selectSnipeTargetList, selectCurrentSnipeTarget } from "../../store/selectors/gachaSelectors";
import FilterSelect from "../../components/filter-select/filter-select";
import getImageFileName from "../../functions/getImageFileName";
import { getUIText } from "../../translation";
import { LOCALES } from "../../constants";
import { loadData } from "../../functions/dataLoader";
import FILTERS from "../../config/filter_config.json";

export default function Gacha() {
    const theme = useSelector((state) => state.theme.value);
    const lang = useSelector((state) => state.lang.value);

    const gacha = useSelector(selectGachaState);
    const snipeGacha = useSelector(selectSnipeGacha);
    const snipeTargetList = useSelector(selectSnipeTargetList);
    const currentSnipeTarget = useSelector(selectCurrentSnipeTarget);

    // const [FILTERS, setFILTERS] = useState(null);

    // useEffect(() => {
    //     loadData("filter_config.json").then(setFILTERS);
    // }, []);

    // if (!FILTERS) return;

    const gachaGroup = lang === LOCALES.KO ? FILTERS.GACHA_GROUP : FILTERS.GACHA_GROUP_ENG;

    // const [isPickup, setIsPickup] = useState(false);
    const [gachaMode, setGachaMode] = useState(gachaGroup[0]);
    const [isPlaying, setIsPlaying] = useState();

    const dispatch = useDispatch();

    useEffect(() => {
        if (typeof isPlaying === "number" && snipeGacha.latestList.findIndex((e) => e.name === currentSnipeTarget) !== -1) {
            clearInterval(isPlaying);
            setIsPlaying(undefined);
            return;
        }
    }, [gacha]);

    // 저격 탭 선택 시 기본값 설정
    useEffect(() => {
        if (gachaMode.value === GACHA_TYPE.SNIPE && !snipeGacha.target && snipeTargetList.length > 0) {
            dispatch(setSnipeTarget(snipeTargetList[0]));
        }
    }, [gachaMode, snipeGacha.target, snipeTargetList]);

    // 구원자/아르카나 타입 변경 시 target 업데이트
    useEffect(() => {
        if (gachaMode.value === GACHA_TYPE.SNIPE && snipeTargetList.length > 0) {
            // 현재 target이 새 목록에 없으면 첫 번째 항목으로 설정
            if (!snipeTargetList.includes(snipeGacha.target)) {
                dispatch(setSnipeTarget(snipeTargetList[0]));
            }
        }
    }, [snipeTargetList, snipeGacha.target, gachaMode]);

    const getPercent = (value) => {
        return `${(value * 100).toFixed(2)}%`;
    };

    const startAutoPlay = () => {
        const timer = setInterval(() => {
            dispatch(tryTen({ type: { value: GACHA_TYPE.SNIPE, name: "저격" }, lang }));
        }, 50); // 10ms -> 50ms로 변경하여 CPU 부하 감소

        setIsPlaying(timer);
    };

    return (
        <div id="container" data-theme={theme} data-lang={lang}>
            {theme === "dark" && <StarContainer />}
            <Header title={getUIText(lang, "header.title.gacha")} />

            <div className={styles["gacha-container"]}>
                {/* TODO : tabs */}
                <div className={styles["tabs"]}>
                    {gachaGroup.map((group) => {
                        return (
                            <button
                                type="button"
                                className={`${styles["tab-button"]} ${group.value === gachaMode.value ? `${styles["active"]}` : ""}`}
                                onClick={() => setGachaMode(group)}
                                key={v4()}
                            >
                                {group.name}
                            </button>
                        );
                    })}
                </div>

                {/* TODO : isPickup selector */}
                <div className={styles["mode-selector-wrapper"]}>
                    <div className={styles["mode-selector"]}>
                        <button
                            type="button"
                            className={`${gacha.isPickup ? "" : `${styles["active"]}`}`}
                            onClick={() => {
                                dispatch(setIsPickup(false));
                                // 통상 선택 시 첫 번째 목록으로 target 업데이트
                                if (snipeTargetList.length > 0) {
                                    dispatch(setSnipeTarget(snipeTargetList[0]));
                                }
                            }}
                        >
                            {getUIText(lang, "gacha.type.standard")}
                        </button>
                        <button
                            type="button"
                            className={`${gacha.isPickup ? `${styles["active"]}` : ""}`}
                            onClick={() => {
                                dispatch(setIsPickup(true));
                                // 픽업 선택 시 첫 번째 목록으로 target 업데이트
                                if (snipeTargetList.length > 0) {
                                    dispatch(setSnipeTarget(snipeTargetList[0]));
                                }
                            }}
                        >
                            {getUIText(lang, "gacha.type.featured")}
                        </button>
                    </div>
                    {gachaMode.value === GACHA_TYPE.SAVIOR && gacha.isPickup && gacha.pickupHasCosmic && (
                        <div className={styles["target-type-selector"]}>
                            <button
                                type="button"
                                className={`${gacha.saviorPickupType === SSR_TYPE.NOT_COSMIC ? `${styles["active"]}` : ""}`}
                                onClick={() => dispatch(setSaviorPickupType(SSR_TYPE.NOT_COSMIC))}
                            >
                                {getUIText(lang, "gacha.target.normal")}
                            </button>
                            <button
                                type="button"
                                className={`${gacha.saviorPickupType === SSR_TYPE.COSMIC ? `${styles["active"]}` : ""}`}
                                onClick={() => dispatch(setSaviorPickupType(SSR_TYPE.COSMIC))}
                            >
                                {getUIText(lang, "gacha.target.cosmic")}
                            </button>
                        </div>
                    )}
                </div>

                {/* TODO : summon buttons */}
                <div className={styles["gacha-buttons"]}>
                    {gachaMode.value !== GACHA_TYPE.SNIPE && (
                        <button type="button" className={styles["one"]} onClick={() => dispatch(tryOne({ type: gachaMode, lang }))}>
                            {getUIText(lang, "gacha.buttons.summonOne")}
                        </button>
                    )}
                    {gachaMode.value !== GACHA_TYPE.SNIPE && (
                        <button type="button" className={styles["ten"]} onClick={() => dispatch(tryTen({ type: gachaMode, lang }))}>
                            {getUIText(lang, "gacha.buttons.summonTen")}
                        </button>
                    )}
                    {gachaMode.value === GACHA_TYPE.SNIPE && (
                        <div className={styles["snipe-controller"]}>
                            <div className={styles["snipe-settings"]}>
                                <FilterSelect
                                    list={lang === LOCALES.KO ? FILTERS.GACHA_SNIPE_TYPE : FILTERS.GACHA_SNIPE_TYPE_ENG}
                                    selected={gacha.snipe.type}
                                    changeFilter={setSnipeType}
                                />
                                <FilterSelect
                                    list={snipeTargetList}
                                    selected={currentSnipeTarget}
                                    changeFilter={setSnipeTarget}
                                    // forceWidth={snipeGacha.type === "아르카나" ? 200 : 150}
                                    forceWidth={"200px"}
                                />
                            </div>
                            <div className={styles["controller"]}>
                                <button
                                    type="button"
                                    className={styles["start"]}
                                    disabled={isPlaying !== undefined ? true : false}
                                    onClick={() => startAutoPlay()}
                                >
                                    {getUIText(lang, "gacha.buttons.snipe.start")}
                                </button>
                                <button
                                    type="button"
                                    className={styles["stop"]}
                                    disabled={typeof isPlaying !== "number" ? true : false}
                                    onClick={() => {
                                        clearInterval(isPlaying);
                                        setIsPlaying(undefined);
                                    }}
                                >
                                    {getUIText(lang, "gacha.buttons.snipe.stop")}
                                </button>
                                <button
                                    type="button"
                                    className={styles["reset"]}
                                    disabled={isPlaying !== undefined ? true : false}
                                    onClick={() => dispatch(reset(gachaMode))}
                                >
                                    {getUIText(lang, "gacha.buttons.snipe.reset")}
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                {/* TODO : result container */}
                {/* TODO : total result container */}
                <div className={styles["result-container"]}>
                    <div className={styles["card-list"]}>
                        {gacha[gachaMode.value].latestList.map((result) => {
                            if (result.id === GRADE.R) {
                                return (
                                    <div className={`${styles["card"]} ${styles["R"]} ${styles["default"]}`} key={v4()}>
                                        <img src={`${process.env.PUBLIC_URL}/images/cards/아르카나.webp`} />
                                        <span>{getUIText(lang, "gacha.buttons.result.arcana")}</span>
                                    </div>
                                );
                            } else {
                                return (
                                    <div
                                        className={`${styles["card"]} ${
                                            (gachaMode.value === GACHA_TYPE.SNIPE && result.name === currentSnipeTarget) || result.isPickup
                                                ? `${styles["sniped"]}`
                                                : result.isSSR
                                                  ? `${styles["SSR"]}`
                                                  : `${styles["SR"]}`
                                        }`}
                                        key={v4()}
                                    >
                                        <img
                                            src={
                                                gachaMode.value === GACHA_TYPE.ARCANA || result.gachaType === "arcana"
                                                    ? `${process.env.PUBLIC_URL}/images/cards/${getImageFileName(result.img)}.webp`
                                                    : `${process.env.PUBLIC_URL}/images/illust/gacha/${result.img}.webp`
                                            }
                                        />
                                        <span>{result.name}</span>
                                    </div>
                                );
                            }
                        })}
                        {gacha[gachaMode.value].latestList.length === 0 && (
                            <div className={styles["guide-msg"]}>{getUIText(lang, "gacha.buttons.result.blank")}</div>
                        )}
                    </div>
                    <div className={styles["results"]}>
                        <div className={styles["texts"]}>
                            <div className={styles["result"]}>
                                <div className={styles["title"]}>{getUIText(lang, "gacha.buttons.result.total")}</div>
                                <div className={styles["value"]}>{gacha[gachaMode.value].total}</div>
                            </div>
                            <div className={styles["result"]}>
                                <div className={styles["title"]}>{getUIText(lang, "gacha.buttons.result.ssr.count")}</div>
                                <div className={styles["value"]}>{gacha[gachaMode.value].ssr}</div>
                            </div>
                            <div className={styles["result"]}>
                                <div className={styles["title"]}>{getUIText(lang, "gacha.buttons.result.ssr.rate")}</div>
                                <div className={styles["value"]}>
                                    {getPercent(
                                        gacha[gachaMode.value].total === 0 ? 0 : gacha[gachaMode.value].ssr / gacha[gachaMode.value].total,
                                    )}
                                </div>
                            </div>
                            <div className={styles["result"]}>
                                <div className={styles["title"]}>{getUIText(lang, "gacha.buttons.result.featured.count")}</div>
                                <div className={styles["value"]}>{gacha[gachaMode.value].pickup}</div>
                            </div>
                            <div className={styles["result"]}>
                                <div className={styles["title"]}>{getUIText(lang, "gacha.buttons.result.featured.rate")}</div>
                                <div className={styles["value"]}>
                                    {getPercent(
                                        gacha[gachaMode.value].total === 0
                                            ? 0
                                            : gacha[gachaMode.value].pickup / gacha[gachaMode.value].total,
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={styles["badges"]}>
                            {Object.keys(gacha[gachaMode.value].results).map((charName) => {
                                const result = gacha[gachaMode.value].results[charName];
                                if (result.id === "R") return;

                                return (
                                    <span
                                        className={`${styles["badge"]} ${
                                            (gachaMode.value === GACHA_TYPE.SNIPE && charName === currentSnipeTarget) || result.isPickup
                                                ? `${styles["sniped"]}`
                                                : result.isSSR
                                                  ? `${styles["SSR"]}`
                                                  : `${styles["SR"]}`
                                        }`}
                                        // ${
                                        //     gacha[gachaMode.value].results[charName].isSSR ? `${styles["SSR"]}` : `${styles["SR"]}`
                                        // }`}
                                        key={v4()}
                                    >
                                        {charName} * {gacha[gachaMode.value].results[charName].count}
                                    </span>
                                );
                            })}
                        </div>
                        <button type="button" className={styles["reset-button"]} onClick={() => dispatch(reset(gachaMode))}>
                            {getUIText(lang, "gacha.buttons.result.reset")}
                        </button>
                    </div>
                </div>
            </div>

            <ScrollUpButton />
            <Footer />
        </div>
    );
}
